import { Directive, Input, ViewContainerRef, TemplateRef } from '@angular/core';
import { SessionDataService } from 'inova-front-core/session';

@Directive({
  selector: '[requireRol]'
})
export class InovaRequireRoleDirective {
  @Input('requireRol') set requireRol(roles: string[]) {
      let userRole= this.sessionService.getUserRole();
      if(! roles.includes(userRole)){
        this.viewContainer.clear();
      }else{
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
  }
  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private sessionService:SessionDataService) {
  }
}
